<template>
  <div @contextmenu="selectComponentDEV($event, schema.model)" :class="[getSelectedDEV && 'dev-selected-component']">
    <component v-if="schema.attributes.title" v-bind="schema.attributes.title" :is="schema.attributes.title.tag">
      <v-icon
        v-if="schema.attributes.title.appendIcon && schema.attributes.title.appendIcon.left"
        v-bind="schema.attributes.title.appendIcon.attributesIcon"
        >{{ schema.attributes.title.appendIcon.icon }}</v-icon
      >
      {{ schema.attributes.title.text }}
      <v-icon
        v-if="schema.attributes.title.appendIcon && schema.attributes.title.appendIcon.right"
        v-bind="schema.attributes.title.appendIcon.attributesIcon"
        >{{ schema.attributes.title.appendIcon.icon }}</v-icon
      >
    </component>

    <component v-if="schema.attributes.subTitle" v-bind="schema.attributes.subTitle" :is="schema.attributes.subTitle.tag">
      <v-icon
        v-if="schema.attributes.subTitle.appendIcon && schema.attributes.subTitle.appendIcon.left"
        v-bind="schema.attributes.subTitle.appendIcon.attributesIcon"
        >{{ schema.attributes.subTitle.appendIcon.icon }}</v-icon
      >
      {{ value ? value : schema.attributes.subTitle.text }}
      <v-icon
        v-if="schema.attributes.subTitle.appendIcon && schema.attributes.subTitle.appendIcon.right"
        v-bind="schema.attributes.subTitle.appendIcon.attributesIcon"
        >{{ schema.attributes.subTitle.appendIcon.icon }}</v-icon
      >
    </component>
  </div>
</template>

<script>
import { abstractField } from 'vue-form-generator';
import devComponentMixin from '@/mixins/dev-component-mixin';

export default {
  mixins: [abstractField, devComponentMixin]
};
</script>
